import { createSelector } from '@ngrx/store';
import { AppState } from '../index';
import { featureKey, State } from './wordpress.reducer';


export const WordpressState = (state: AppState) => state[featureKey];

export const selectCategories = createSelector(
  WordpressState,
  (state: State) => state.categories,
);

export const selectCommonData = createSelector(
  WordpressState,
  (state: State) => state.commonData,
);

export const selectDocumentaries = createSelector(
  WordpressState,
  (state: State) => state.documentaries,
);

